<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            重名查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="gjbh" clearable label="查询公安办件数据:" placeholder="请输入政务网编号"/>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-if="listShow">
            <div class="boxList-item">
                <span>事项名称</span>
                <span>{{dataList.matName}}</span>
            </div>
            <div class="boxList-item">
                <span>部门名称 :</span>
                <span>{{dataList.deptName}}</span>
            </div>
            <div class="boxList-item">
                <span>公安系统办件编号:</span>
                <span>{{dataList.tskNum}}</span>
            </div>
            <div class="boxList-item">
                <span>申请人姓名:</span>
                <span>{{dataList.unitname}}</span>
            </div>
            <div class="boxList-item">
                <span>申请人手机号码:</span>
                <span>{{dataList.handphone}}</span>
            </div>
            <div class="boxList-item">
                <span>申报时间:</span>
                <span>{{dataList.creatorDate}}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button} from 'vant'
    import {queryApiMap} from "@/api/query";

    export default {
        name: "SzfBaseQuery",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                gjbh : '', // 姓名
                value: '',
                listShow: false,//查询结果的显示与隐藏
                dataList:{} //用于查询后存放数据
            }
        },
        mounted(){
          this.logger.visit('107','0')
        },
        methods: {

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                  tskNum: this.gjbh,
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryName1Szf}`, data)
              this.show = false
              //关闭加载
                if (res.data.succ) {
                    let data = res.data.data;
                    if (data.length > 0) {
                        this.dataList = Object.assign([], data)
                        this.listShow = true
                    } else {
                        Toast.fail('未查询到相关数据,请排查受理平台数据是否分发')
                    }
                } else {
                    Toast.fail(res.data.msg)
                }
              this.logger.visit('107','1')
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            async submit() {
              console.log(11111111111111)
                if (!this.gjbh) {
                    Toast('请输入姓名')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        let queryParam ={
                            "tskNum": this.gjbh
                        }
                        const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.queryName1Szf}`, queryParam)
                        Toast.clear()
                        // if (res.data.succ) {
                        //     Toast.clear()
                        //     this.dataList = Object.assign([], res.data.data)
                        //     this.listShow = true
                        // } else {
                        //     Toast.fail('查询失败')
                        // }
                        if (res.data.succ) {
                            let data = res.data.data;
                            console.log(data)
                                this.dataList = Object.assign([], data)
                                this.listShow = true
                        } else {
                            Toast.fail(res.data.msg)
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },

            /**
             * 点击查询
             */
            async query() {
                if (!this.gjbh) {
                    Toast('请输入姓名')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            tskNum: this.gjbh,
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryName1Szf}`, data)
                        // if (res.data.succ) {
                        //     Toast.clear()
                        //     this.dataList = Object.assign([], res.data.data)
                        //     this.listShow = true
                        // } else {
                        //     Toast.fail('查询失败')
                        // }
                        if (res.data.succ) {
                            let data = res.data.data;
                            if (data.length > 0) {
                                this.dataList = Object.assign([], data)
                                this.listShow = true
                            } else {
                                Toast.fail('未查询到相关数据,请排查受理平台数据是否分发')
                            }
                        } else {
                            Toast.fail(res.data.msg)
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
